














import { computed, defineComponent } from "@vue/composition-api";
import Message from "@/components/Message.vue";
import injectStrict from "@/utilities/injectstrict";
import { TestUserKey } from "../symbols";
import IButton from "@/interfaces/IButton";

export default defineComponent({
  components: {
    Message,
  },
  setup(_, { root }) {
    const user = injectStrict(TestUserKey);
    return {
      primaryButton: computed<IButton>(() => {
        return {
          title: root.$tc("users.show"),
          variant: "success",
          onClick: async () => {
            await root.$router.back();
            setTimeout(() => {
              root.$router.push({
                name: "TestUser",
                params: { id: user.id?.toString() ?? "" },
              });
            }, 500);
          },
        };
      }),
      secondaryButton: computed<IButton>(() => {
        return {
          title: root.$tc("common.done"),
          variant: "info",
          onClick: () => {
            root.$router.back();
          },
        };
      }),
    };
  },
});
